import React from 'react';

import Modal from '../../../../../../../../components/Modal';
import Table from '../../../../../../../../components/_table/Table/Table';
import { columns } from './columns';
import { SearchEventItemType, SearchOptionType } from './types';
import { INITIAL_OPTION } from './SearchEventListModalContainer';

interface ISearchEventListModalViewProps {
  isOpen?: true;
  closeModal: () => void;
  onSubmit: () => void;
  eventList: SearchEventItemType[];
  totalCount: number;
  option: SearchOptionType;
  dispatchOption: (data: SearchOptionType) => void;
  selectedIdList: number[];
  onCheck: (idList: number[], id: number) => void;
}
const SearchEventListModalView = (props: ISearchEventListModalViewProps) => {
  const {
    isOpen = true,
    closeModal,
    onSubmit,
    eventList,
    totalCount,
    option,
    dispatchOption,
    selectedIdList,
    onCheck,
  } = props;

  return (
    <Modal
      title="기획전 검색"
      isOpen={isOpen}
      width={1014}
      height={650}
      isFooter={true}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="search-item-modal">
        <div className="help-text">*어드민에 등록 된 기획전 리스트 입니다.</div>
        <Table
          columns={(utils: any) =>
            columns({
              ...utils,
              isFilter: true,
            })
          }
          rowKey={(record: SearchEventItemType) => record.id}
          list={eventList}
          size="small"
          scroll={{ x: true }}
          bordered={true}
          initialOption={INITIAL_OPTION}
          filterOption={option.filterOption}
          pagination={{ ...option.pagination, totalCnt: totalCount }}
          getList={({ filterOption, pagination }: SearchOptionType) => {
            dispatchOption({ filterOption, pagination });
          }}
          selectedList={selectedIdList}
          onCheck={onCheck}
        />
      </div>
    </Modal>
  );
};

export default SearchEventListModalView;
